import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import BaseModal from '../BaseModal';
import EditUserForm from './EditUserForm';
import { editShipping } from 'actions/shippings';
import { findPurchase } from 'actions/purchases';
import { saveUser, getUsersApiOptions } from 'actions/users';
import Spinner from 'components/Spinner';
import {
  getIncludedInGroups,
  getIsResellerGroup,
  getLoggedInUser,
} from 'reducers';
import {
  caretUserNavSafariFix,
  filterUserAclChoices,
  managerUserAclGroups,
} from 'helpers/user';
import { can, permActions } from '../../../permissions';

class EditShippingDetailsModal extends Component {
  state = {
    isOpen: false,
    loading: false,
    userTypes: [],
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isOpen && this.state.isOpen && !this.state.simoAccounts) {
      this.fetchUserTypes();
    }
  }

  fetchUserTypes = () => {
    const { isAdmin, isResellerGroup, isManager, user } = this.props;

    if (isAdmin || isResellerGroup) {
      getUsersApiOptions().then((res) => {
        if (res.error) {
          return;
        }

        const { choices } = res.acl_group_name;
        const filteredChoices = filterUserAclChoices(user, choices);

        this.setState({
          userTypes: filteredChoices.map(({ value }) => [value, value]),
        });
      });
    } else if (isManager) {
      this.setState({
        userTypes: managerUserAclGroups.map((value) => [value, value]),
      });
    }
  };

  handleEditUser = (values) => {
    const { saveUser, user } = this.props;

    this.setState({ loading: true });
    return saveUser({ id: user.id, ...values }, 'PATCH')
      .then(() => {
        this.closeModal();
        toast.success('User details updated');
        caretUserNavSafariFix();
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  getInitialValues = (showAclGroup, showEmail) => {
    const { user, isResellerGroup } = this.props;
    const initialValues = {
      first_name: user?.first_name || '',
      last_name: user?.last_name || '',
      company_name: user?.company_name || '',
      phone_number: user?.phone_number || '',
    };

    if (!isResellerGroup) {
      initialValues.reference = user?.reference || '';
    }

    if (showEmail) {
      initialValues.email = user?.email;
    }

    if (showAclGroup) {
      initialValues.acl_group_name = user.acl_group_name;
    }

    return initialValues;
  };

  render() {
    const { user, isResellerGroup, loggedInUser } = this.props;
    const { isOpen, loading, userTypes } = this.state;

    const showEmail = can(loggedInUser, permActions.EDIT_USER_EMAIL, {
      user,
    });
    const showAclGroup = can(loggedInUser, permActions.EDIT_USER_GROUP, {
      user,
    });
    const canEditProfile = can(loggedInUser, permActions.EDIT_USER_PROFILE, {
      user,
      loggedInUser,
    });
    const initialValues = this.getInitialValues(showAclGroup, showEmail);

    if (!canEditProfile) {
      return null;
    }

    return (
      <React.Fragment>
        <button className="btn btn-default" onClick={this.openModal}>
          Edit User Details
        </button>
        <BaseModal
          isOpen={isOpen}
          title="Edit User Details"
          onClose={this.closeModal}
          confirmBtnText=""
          cancelBtnText=""
        >
          <EditUserForm
            isResellerGroup={isResellerGroup}
            initialValues={initialValues}
            userTypes={userTypes}
            user={user}
            showEmail={showEmail}
            showAclGroup={showAclGroup}
            onSubmit={this.handleEditUser}
          />
          <Spinner showLoader={loading} />
        </BaseModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isManager: getIncludedInGroups(state, 'MANAGER'),
  isAdmin: getIncludedInGroups(state, 'ADMIN'),
  isResellerGroup: getIsResellerGroup(state),
  loggedInUser: getLoggedInUser(state),
});

const mapDispatchToProps = {
  editShipping,
  findPurchase,
  saveUser,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditShippingDetailsModal);
